// Groups thousands with commas. Numeric input is rounded to at most 2 decimals
// first: fees like `amount * 0.008` otherwise print float noise
// (2400.0000000004) and the old regex also put commas inside the decimals.
export const currencyFormatter = (value = "", symbol) => {
  if (value === null || value === undefined || value === "") return null;

  const suffix = symbol === "" || symbol === undefined ? "" : ` ${symbol}`;
  const number = Number(value);

  if (Number.isFinite(number)) {
    const formatted = number.toLocaleString("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });
    return `${formatted}${suffix}`;
  }

  return `${String(value).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}${suffix}`;
};
